import {FC} from 'react';
import {Close} from '@mui/icons-material';
import {Box, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {AMPModalProps} from './AmpModal.types';
import {useScreenTier} from 'src/hooks/useScreenTier';
import {contentSx, headerSx, rootSx, titleSx} from './AMPModal.sx';

const AMPModal: FC<AMPModalProps> = ({
                                         handleClose,
                                         open,
                                         children,
                                         title,
                                         type,
                                         fullWidth,
                                         withoutPaddings = false,
                                     }) => {
    // On a phone a dialog is a screen, not a box. At 8px margins a form still scrolled inside a page
    // that also scrolled, and the on-screen keyboard covered most of what was left.
    const {isPhone} = useScreenTier();

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            sx={rootSx}
            maxWidth={type ?? 'lg'}
            fullWidth={fullWidth ?? false}
            fullScreen={isPhone}
        >
            {title && (
                <Box sx={headerSx}>
                    <DialogTitle sx={titleSx}>{title}</DialogTitle>
                    <IconButton onClick={handleClose}>
                        <Close/>
                    </IconButton>
                </Box>
            )}
            <DialogContent sx={contentSx(withoutPaddings)}>{children}</DialogContent>
        </Dialog>
    );
};

export default AMPModal;
